
import "./milestones.css";
import { fmtCurrencyBR, fmtNumberBR } from "../../utils/formatBrl";

export default function MilestoneCard({ milestone, username }) {
  if (!milestone) return null;

  console.log('[MilestoneCard] Rendering with milestone:', milestone);

  const progress = Number(milestone.progress ?? 0);
  const isLocked = progress < 100;

  return (
    <div className="milestone-card">
      <div className="milestone-header">
        <h3 className="milestone-title">
          Sua próxima premiação,<br /> {username} 🎉
        </h3>
      </div>

      {/* Badge */}
      <div className="milestone-badge-container">
        <img
         src={require(`../../static/images/milestones/${milestone.image}`)}
          alt={milestone.label}
          className={`milestone-badge ${isLocked ? "locked" : ""}`}
          onError={(e) => {
            e.currentTarget.style.display = "none";
          }}
        />
      </div>

      {/* Valor atual */}
      <div className="milestone-value">
        <div
          className="chart-value"
          style={{ marginBottom: 0 }}
        >
          {fmtCurrencyBR.format(milestone.current)}
        </div>
      </div>

      {/* Barra de progresso */}
      <div className="milestone-progress-container">
        <div className="milestone-progress-bar">
          <span className="milestone-progress-text">
            {progress}%
          </span>

          <div
            className="milestone-progress-fill"
            style={{ width: `${progress}%` }}
          />
        </div>

        {/* Tooltip (estrutura mantida) */}
        <div id="milestoneTooltip" className="milestone-tooltip">
          <div>
            <strong>Faturamento:</strong> {fmtCurrencyBR.format(milestone.current)}
          </div>
        </div>
      </div>

      {/* Stats */}
      <div className="milestone-stats">
        <span>
          {milestone.completed && "🎉 Meta concluída!"}
        </span>

        <span
          style={{
            color: "var(--text-secondary)",
            fontWeight: 600,
            margin: "0 auto",
            textAlign: "center",
            fontSize: "small",
          }}
        >
          {progress}% da jornada foi atingida. Continue firme!
        </span>
      </div>
    </div>
  );
}
